import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const providerIgnoredRequestsListColumns = [
  'providerIgnoredRequests.startDate',
  'providerIgnoredRequests.endDate',
  'providerIgnoredRequests.betId',
  'providerIgnoredRequests.amount',
] as const;

export type ProviderIgnoredRequestsListColumns =
  (typeof providerIgnoredRequestsListColumns)[number];

export type ProviderIgnoredRequestsListFilter = {
  'providerIgnoredRequests.startDate': string | undefined;
  'providerIgnoredRequests.endDate': string | undefined;
  'providerIgnoredRequests.betId': string | undefined;
  'providerIgnoredRequests.amount': string | undefined;
};

export const defaultProviderIgnoredRequestsListFilter: ProviderIgnoredRequestsListFilter = {
  'providerIgnoredRequests.startDate': undefined,
  'providerIgnoredRequests.endDate': undefined,
  'providerIgnoredRequests.betId': undefined,
  'providerIgnoredRequests.amount': undefined,
};

export const providerIgnoredRequestsListColumnVisibilitySettings = {
  'providerIgnoredRequests.startDate': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.endDate': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.betId': ColumnVisibilityType.CanBeHidden,
  'providerIgnoredRequests.amount': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<ProviderIgnoredRequestsListColumns>;

export const defaultProviderIgnoredRequestsListColumnVisibility = defaultColumnVisibilityParams(
  providerIgnoredRequestsListColumnVisibilitySettings
);

export const providerIgnoredRequestsListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  providerIgnoredRequestsListColumns,
  providerIgnoredRequestsListColumnVisibilitySettings
);
